// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q3/2023sport_essay/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};
const ifSave = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}if-save`, qsData);
};
const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};
const getList = (page:any, keyword:any) => {
  return http.get(`${urlPrefix}vote-list&page=${page}&search=${keyword}`);
};
const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};
// 获取作文详情页面
const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail&id=` + id);
};
export { getBaseInfo, save, ifSave, getRule, getList, getNews, getDetail };
